import React, { useEffect } from 'react';
import ServiceCard from '../ServiceCard';
import { services } from '../../data/services';
import { useLanguage } from '../../context/LanguageContext';
import PageHero from '../PageHero';
import { Sparkles, ShieldCheck, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const Services = () => {
  const { t, language } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const highlight1 = language === 'mr' ? '१६+ विशेष उपचार' : (language === 'kn' ? '೧೬+ ವಿಶೇಷ ಚಿಕಿತ್ಸೆಗಳು' : '16+ Specialized Treatments');
  const highlight1Desc = language === 'mr' ? 'लेझर व सूक्ष्म शस्त्रक्रिया' : (language === 'kn' ? 'ಲೇಸರ್ ಮತ್ತು ಮೈಕ್ರೋ ಸರ್ಜರಿ' : 'Laser & Advanced Microsurgery');
  const highlight2 = language === 'mr' ? 'अत्याधुनिक तंत्रज्ञान' : (language === 'kn' ? 'ಅತ್ಯಾಧುನಿಕ ತಂತ್ರಜ್ಞಾನ' : 'Modern Diagnostics & OT');
  const highlight2Desc = language === 'mr' ? 'टाकेविरहित व सुरक्षित उपचार' : (language === 'kn' ? 'ಹೊಲಿಗೆ ರಹಿತ ಮತ್ತು ಸುರಕ್ಷಿತ' : 'Painless & Stitchless Procedures');

  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      {/* Attractive Hero Banner matching Branches.js */}
      <PageHero
        badge={t('servicesSection.badge')}
        title={t('servicesSection.title')}
        subtitle={t('servicesSection.pageSubtitle')}
      />

      {/* Main Content */}
      <div className="container mx-auto px-4 lg:px-8 -mt-16 relative z-20 pb-24">
        {/* Stats / Highlights Row */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 mb-16 flex flex-col md:flex-row justify-center gap-8 md:gap-24 hover:border-gray-300 transition-colors"
        >
          <div className="flex items-center space-x-4">
            <div className="w-14 h-14 bg-white border border-gray-100 text-clinical rounded-full flex items-center justify-center shadow-sm">
              <Sparkles size={24} strokeWidth={1.5} />
            </div>
            <div>
              <h4 className="text-navy font-bold text-xl">{highlight1}</h4>
              <p className="text-gray-500 text-sm">{highlight1Desc}</p>
            </div>
          </div>
          <div className="hidden md:block w-px h-14 bg-gray-200"></div>
          <div className="flex items-center space-x-4">
            <div className="w-14 h-14 bg-white border border-gray-100 text-clinical rounded-full flex items-center justify-center shadow-sm">
              <ShieldCheck size={24} strokeWidth={1.5} />
            </div>
            <div>
              <h4 className="text-navy font-bold text-xl">{highlight2}</h4>
              <p className="text-gray-500 text-sm">{highlight2Desc}</p>
            </div>
          </div>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
